import { SpaceType } from '../api/types/response/booking-rule.response';

export const spaceTypesTranslations = {
  [SpaceType.DESK]: 'createBookingRules.desks',
  [SpaceType.ROOM]: 'createBookingRules.rooms',
} as const;
